/**
 * Operators allowed to bypass the maintenance/migration freeze (`offline` flag)
 * and other admin-only gates that used to keep separate, duplicated copies of
 * this same list (`canSearchAll`/`manualRank` in Users/UsersFunc.ts,
 * `vaultManagers` in Vault/Functions.ts). Single source of truth, consumed by
 * both the frontend router and the backend callables.
 */
export const OPERATOR_ALLOWLIST: readonly string[] = Object.freeze([
  // The company account, now `gtr.master` (renamed from `gtr.academy`,
  // 2026-07-19). The operator login the three partners share to read the
  // company's commissions. Kept as a literal because this file is shared with the
  // frontend and must not depend on functions/_constants.
  "gtr.master",
  // AQUÍ ESTUVO `gtr.academy`, Y SE FUE AL CERRAR LA VENTANA (2026-07-28).
  //
  // Era ESA MISMA cuenta ANTES del renombrado: el rename a `gtr.master` ocurre
  // DENTRO de la ventana, así que durante el congelado la cuenta de la empresa
  // todavía se llamaba así, y sin este nombre no habría podido entrar a prod a
  // tomar las fotos del «antes». Cerrada la migración la cuenta se deshabilita
  // en Auth, y el nombre viejo ya no designa a nadie.
  //
  // Y no era sólo la consola de migración: mientras estuvo, esta línea concedía
  // TAMBIÉN `canSearchAll`, `vaultManagers` y el `manualRank` de COFOUNDER,
  // porque esta lista gobierna las cuatro cosas. Quitarla las cierra las cuatro.
  //
  // ⚠️ NO SE REPONE «por si acaso». Si algún día la empresa tiene que volver a
  // operar, el nombre vivo es `gtr.master`, que está en la línea de arriba.
  "pitgtr",
  "monicamenmal",
  "maph01",
  "pflores",
  "marro1",
]);

export function isOperator(usernamePK: string | null | undefined): boolean {
  if (!usernamePK) return false;
  // Trim as well as lowercase: this gates the freeze bypass, and the failure
  // mode of a stray space (an operator locked out mid-migration) is worse than
  // being permissive about whitespace.
  return OPERATOR_ALLOWLIST.includes(usernamePK.trim().toLowerCase());
}
